/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsPlusIcon24Solid = forwardRef('DocsPlusIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.05 1H7a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V9.05h-5.2a2.75 2.75 0 0 1-2.75-2.75V1ZM11 10.125c.483 0 .875.392.875.875v2.125H14a.875.875 0 0 1 0 1.75h-2.125V17a.875.875 0 0 1-1.75 0v-2.125H8a.875.875 0 0 1 0-1.75h2.125V11c0-.483.392-.875.875-.875Z" }),
        React.createElement("path", { d: "M19 7.55v-.04l-6.45-6.45V6.3c0 .69.56 1.25 1.25 1.25H19Z" }),
        React.createElement("path", { d: "M21.75 9a.75.75 0 0 0-1.5 0v8.5a4.75 4.75 0 0 1-4.75 4.75H9a.75.75 0 0 0 0 1.5h6.5a6.25 6.25 0 0 0 6.25-6.25V9Z" })));
});
